import React, { useEffect, useState } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { Cox2Section } from '../components/Cox2Section';
import { ScienceSection } from '../components/ScienceSection';
import { BundleSection } from '../components/BundleSection';
import { EaseSection } from '../components/EaseSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { WhyWeDoThisSection } from '../components/WhyWeDoThisSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-cream to-mint font-sans text-sage" data-id="element-627">
      <AnnouncementBar data-id="element-628" />
      <HeroSection data-id="element-629" />
      <PainSection data-id="element-630" />
      <Cox2Section data-id="element-631" />
      <ScienceSection data-id="element-632" />
      <BundleSection data-id="element-633" />
      <EaseSection data-id="element-634" />
      <SocialProofSection data-id="element-635" />
      <PricingSection data-id="element-636" />
      <WhyWeDoThisSection bump1={bump1} bump2={bump2} data-id="element-637" />
      <OrderBumpSection bump1={bump1} setBump1={setBump1} bump2={bump2} setBump2={setBump2} data-id="element-638" />
      <TestimonialsSection data-id="element-639" />
      <FAQSection bump1={bump1} bump2={bump2} data-id="element-640" />
      <Footer data-id="element-641" />
    </div>;
}